import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../../components/Button/Button';
import { SubProfessionPicker, SubProfOption } from './SubProfessionPicker';

interface Props {
  // Effective sub-profession ids already linked to the focus category.
  linkedSubProfessionIds: Set<number>;
  onAdd: (sub: SubProfOption) => void;
  disabled?: boolean;
}

// Category-mode counterpart of CategoryLinkEditor: link a sub-profession TO the
// focused category (editing the same junction from the other side).
export const SubProfessionLinkEditor: React.FC<Props> = ({
  linkedSubProfessionIds,
  onAdd,
  disabled,
}) => {
  const [selected, setSelected] = useState<SubProfOption | null>(null);
  const alreadyLinked = selected ? linkedSubProfessionIds.has(selected.id) : false;

  const handleAdd = () => {
    if (!selected || alreadyLinked) return;
    onAdd(selected);
    setSelected(null);
  };

  return (
    <Box className="flex flex-col gap-3">
      <Typography fontWeight={600} sx={{ fontSize: 14 }}>
        Add a sub-profession link
      </Typography>
      <SubProfessionPicker value={selected} onChange={setSelected} />
      {alreadyLinked && (
        <Typography color="var(--down)" sx={{ fontSize: 12 }}>
          {selected?.name} is already linked.
        </Typography>
      )}
      <Box>
        <Button onClick={handleAdd} disabled={disabled || !selected || alreadyLinked} className="!px-5">
          <Typography>{selected ? `Add ${selected.name}` : 'Add link'}</Typography>
        </Button>
      </Box>
    </Box>
  );
};
